module.exports = __webpack_public_path__ + "static/media/BS.e3c9eb9c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/BS.svg
// module id = 211
// module chunks = 0